import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

function useDtMultiplier() {
  const { cb, key } = fetch();
  const { data, isSuccess, refetch } = useQuery(key, cb, { staleTime: Infinity });

  return { data, isSuccess, refetch };
}

export default {
  useDtMultiplier,
};
